// Wortlaute der Erklärung „Lieferanten“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter, Felder und Schaltflächen stehen so, wie die Seiten sie zeigen (../supplier.js,
// ../supplierInsights.js, ../supplierHistory.js, ../supplierImport.js).
export default {
  title: "Lieferanten",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    SupplierOverview: "Übersicht",
    SupplierSetup: "Einrichten",
    SupplierComparison: "Vergleich",
    SupplierDetail: "Lieferant",
    MaterialDetail: "Material",
    ProjectDetail: "Projekt",
  },
  // Die Seiten außerhalb der Lieferanten, in denen ihre Preise ankommen. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier stehen alle Lieferanten, bei denen Ihr Betrieb Material kauft oder Maschinen mietet. Ein Klick auf eine Zeile öffnet den Lieferanten.",
    },
    row: {
      text: "Unter dem Namen stehen Art, Ort und weitere Standorte, so unterscheiden Sie zwei Filialen derselben Firma. Rechts steht, wen Sie dort anrufen.",
    },
    create: {
      text: "Neuen Lieferanten erstellen öffnet das leere Formular. Es braucht nur einen Namen.",
    },
    invitation: {
      text: "Noch gehören Ihre Einkaufspreise zu keinem Lieferanten. Lieferanten einrichten macht aus ihren Bezeichnungen in einem Schritt Lieferanten.",
    },
    views: {
      text: "Hier wechseln Sie zum Vergleich. Er zeigt, wo ein anderer Lieferant günstiger ist als Ihr Standard.",
    },
    "setup-table": {
      text: "Hier steht jede Bezeichnung, unter der Ihre Einkaufspreise bisher stehen. Daneben, bei wie vielen Materialien und Maschinen sie vorkommt.",
    },
    "setup-target": {
      text: "Rechts wählen Sie, wer daraus wird, ein neuer Lieferant, ein vorhandener oder der Eigene Betrieb. Gehören zwei Bezeichnungen zu einer Firma, wählen Sie bei beiden denselben Lieferanten.",
    },
    "setup-preview": {
      text: "Vorschau nennt die Lieferanten, die neu angelegt werden. Steht dort ein Name, der kein Lieferant ist, wählen Sie oben einen anderen.",
    },
    "setup-apply": {
      text: "Einrichten fragt noch einmal nach. Danach gehört jeder Einkaufspreis einem Lieferanten, und Preise ändern Sie dort im Sortiment.",
    },
    comparison: {
      text: "Der Vergleich zeigt, wo Sie günstiger einkaufen könnten.",
    },
    "comparison-cards": {
      text: "Zwei Lieferanten nebeneinander, je eine Karte. Beide zeigen die Materialien, die beide führen, Zeile für Zeile. Der günstigere Preis steht fett und grün, der Stern zeigt Ihren Standard.",
    },
    "comparison-pick": {
      text: "Oben in jeder Karte wählen Sie den Lieferanten. Darunter steht, bei wie vielen gemeinsamen Materialien er der günstigere ist.",
    },
    "comparison-only": {
      text: "Was nur dieser Lieferant führt, steht zugeklappt unter seiner Karte.",
    },
    "comparison-add": {
      text: "Das Plus neben den Karten stellt einen weiteren Lieferanten daneben, bis zu sechs. Ab drei Karten hat jede ein Kreuz zum Entfernen.",
    },
    "comparison-history": {
      text: "Ein Klick auf eine Zeile zeigt den Preisverlauf des Materials bei den verglichenen Lieferanten.",
    },
    head: {
      text: "Der Kopf trägt den Namen des Lieferanten. Unter Aktionen archivieren Sie ihn, wenn Sie dort nicht mehr kaufen.",
    },
    tabs: {
      text: "Die Reiter teilen die Seite auf. Welcher Reiter offen ist, steht in der Adresse der Seite.",
    },
    base: {
      text: "Name und Art sind die Stammdaten. Arten wie Baustoffhandel oder Mietpark legen Sie direkt in der Auswahl an.",
    },
    reach: {
      text: "Telefon, E-Mail und Website, dazu die Kundennummer, unter der Ihr Betrieb beim Lieferanten geführt wird.",
    },
    address: {
      text: "Der Hauptsitz des Lieferanten. Wählen Sie die Anschrift über die Suche aus, weitere Adressen sind Standorte.",
    },
    discount: {
      text: "Der Rabatt wird mit jedem Preis dieses Lieferanten gebucht. Eine Änderung gilt ab heute, frühere Buchungen behalten ihren Rabatt.",
    },
    terms: {
      text: "Skonto und Fracht werden nicht gebucht. Sie zählen, wenn der Einkauf eines Materials oder der Vergleich Preise frei Baustelle rechnet.",
    },
    // Der Knopf „Miete und Transport“, die Konditionen eines Mietlieferanten. Krämer führt keine Maschinen.
    transport: {
      text: "Miete und Transport gelten für Mietmaschinen: Miettage, Tage ohne Einsatz und der Transporttarif. Sie stehen bei Lieferanten mit Maschinen im Sortiment, bei allen anderen blendet dieser Knopf sie ein.",
    },
    contacts: {
      text: "Hier stehen Ihre Ansprechpartner beim Lieferanten mit Position und Telefon. Gespeichert werden sie mit Speichern.",
    },
    locations: {
      text: "Standorte sind weitere Adressen des Lieferanten, etwa ein Lager, mit Telefon, Disposition und eigenen Ansprechpartnern. Sie teilen seine Preise.",
    },
    assortment: {
      text: "Das Sortiment zeigt, was der Lieferant führt, mit dem Preis von heute. Der Stift ändert einen Preis. Oben wechseln Sie zwischen Materialien und Maschinen; unter einer Maschine steht ihr Zubehör.",
    },
    "assortment-rows": {
      text: "Der Stern markiert den Standard, mit dem ein Projekt das Material übernimmt. Ein Klick auf den Namen öffnet den Einkauf des Materials.",
    },
    following: {
      text: "Nach einer rückwirkenden Änderung bleiben gebuchte Berichte beim alten Preis. Umstellen bringt sie auf den Preis ihres Tages.",
    },
    "price-list": {
      text: "Preise ändern öffnet das ganze Sortiment mit den Preisen von heute. Sie tragen die neuen ein, sie gelten ab heute.",
    },
    "price-import": {
      text: "Im ⋮ daneben steht Preisliste importieren: Es liest die Datei des Lieferanten ein und ordnet jede Zeile einem Material oder einer Maschine zu.",
    },
    revisions: {
      text: "Der Verlauf zeigt jeden Preis einer Zeile mit dem Tag, ab dem er gilt. Ein falscher Preis wird hier berichtigt oder entfernt.",
    },
    files: {
      text: "In die Dateiablage legen Sie Preislisten, Rahmenverträge und Zertifikate. Ein Ablaufdatum färbt sich, sobald es näher kommt.",
    },
    activity: {
      text: "Das Protokoll zeigt jede Änderung mit Tag und Person. Unter Verweise steht, welche Materialien und Maschinen bei diesem Lieferanten stehen.",
    },
    save: {
      text: "Speichern schreibt Stammdaten, Konditionen, Ansprechpartner und Standorte auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: wo die Preise eines Lieferanten ankommen.
    "material-purchase": {
      text: "Beim Material treffen sich die Lieferanten. Im Reiter Einkauf steht jeder, der es führt, mit seinem Preis von heute.",
    },
    "project-prices": {
      text: "Im Projekt bucht jeder Bericht den Preis des Lieferanten vom Tag des Berichts. Ein Objektpreis des Lieferanten für das Projekt geht vor.",
    },
  },
}
